import BaseResource from './BaseResource'

export default class Singlecards extends BaseResource<any> {
  endpoint = 'v1/singlecards'
}
